import { Spinner as TGSpinner, styled } from '@mythical/ui'
import { color } from '@mythical/ui'

const Spinner = styled(TGSpinner, {
  color: color.fgPrimary, // BUG: Can't use vars
  variants: {
    secondary: {
      true: {
        color: color.fgSecondary,
      },
    },
  } as const,
})

export default Spinner
